import React, { memo } from 'react';
import classNames from 'classnames';
import { trackHue, trackNames } from './lane';

interface LaneProps {
  index: number,
  className: string,
  left: number,
  width: number,
  selected: boolean
}

export const LaneComponent: React.FC<LaneProps> = memo(props => {
  const [hover, setHover] = React.useState(false);
  const h = trackHue(props.index);
  const v = props.selected ? 29 : hover ? 18 : 7;

  return (
    <div className="LaneComponent"
      style={{
        left: props.left,
        width: props.width
      }}
    >
      <div className={
        classNames('lane', props.className, props.selected && 'selected')}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        style={
          props.className === 'lane-track' ?
            { backgroundColor: `hsl(${h}, 52%, ${v}%)` } :
            {}
        }
      >
      </div>
      <div className="grid-v"></div>
      <div className={classNames('lane-label', props.selected && 'selected')}>
        {props.className === 'lane-track' ? trackNames[props.index] : ''}
      </div>
    </div>
  );
});
